import { BrowserRouter } from "react-router-dom";

import { Toaster } from "@/components/ui/toaster";
import { AuthProvider } from "@/auth/AuthContext";
import { ConfirmProvider } from "@/hooks/useConfirm";
import { AppRoutes } from "@/routes";

export default function App() {
  return (
    <AuthProvider>
      <ConfirmProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster />
      </ConfirmProvider>
    </AuthProvider>
  );
}
